import { createSlice } from "@reduxjs/toolkit";
import InsuranceService from "@src/services/InsuranceService";
import { toast } from "react-toastify";
import CommonService from "@src/services/CommonService";
import { APIResponse } from "../types/Common";
import { STATUS_CODES } from "@src/config/constant";


const Insurance = createSlice({
    name: 'insurance',
    initialState: {
        formConfig: [],
        common: {},
        insuranceList: {},
        insuranceListFilters: {},
        insuranceData: {},
        createInsurance: {},
        resubmissionLeadData: {},
        dashboardCountID: {}
    },
    reducers: {
        formConfig: (state, action) => {
            state.formConfig = action.payload
        },
        config: (state, action) => {
            state.common = action.payload;
        },
        insuranceList: (state, action) => {
            state.insuranceList = action.payload
        },
        insuranceListFilters: (state, action) => {
            state.insuranceListFilters = action.payload
        },
        setInsuranceData: (state, action) => {
            state.insuranceData = action.payload
        },
        createInsurance: (state, action) => {
            state.createInsurance = action.payload
        },
        setResubmissionLeadData: (state, action) => {
            state.resubmissionLeadData = action.payload
        },
        dashboardCountID: (state, action) => {
            state.dashboardCountID = action.payload
        }
    }
})


export default Insurance.reducer


const { formConfig, config, insuranceList, insuranceListFilters, setInsuranceData, createInsurance, setResubmissionLeadData,dashboardCountID } = Insurance.actions



export const getFormConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getFormConfig()
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response?.data?.data?.agencyAppFormField || [])
                        dispatch(formConfig(response?.data?.data?.agencyAppFormField || []));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getMasterConfig()
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response?.data?.data
                        resolve(response?.data?.data || [])
                        dispatch(config(data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const leadListFilters = (params: object) => async (dispatch: any) => {
    dispatch(insuranceListFilters(params));
}

/**
 * Function to make API call to fetch Lead listing
 * @param params 
 * @returns 
 */
export const getInsuranceList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getLeadList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Function to make API call to Raised SOA
 * @param params 
 * @returns 
 */
export const raisedSoa = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.raisedSoa(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                    } else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


/**
 * Function to make API call to claim listing
 * @param params 
 * @returns 
 */
export const getClaimList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getClaimList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


/**
 * Function to make API call to Raise claim
 * @param params 
 * @returns 
 */
export const RaiseClaim = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.RaiseClaim(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        return resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const updateFormConfig = (params: any) => async (dispatch: any) => {
    dispatch(formConfig(params))
}


/* * Function to make API call to fetch data from ORCR document
 * @param params 
 * @returns 
 */
export const uploadAndReadDocument = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getDataFromDocument(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        resolve(response.data)
                        dispatch(setInsuranceData({ ...data }))
                    }
                    else {
                        // let errorMsg = (response && response.data && response.data.message) || ''
                        // if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}
export const savePaymentProofs = async (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.paymentProofDocs(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data);
                    } else {
                        let errorMsg = (response && response.data && response.data.message) || '';
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data);
                    }
                },
                (error: any) => {
                    reject(error);
                }
            );
    });
};


export const getLeadPaymentDetails = async (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getLeadPaymentDetails(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data);
                    } else {
                        let errorMsg = (response && response.data && response.data.message) || '';
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data);
                    }
                },
                (error: any) => {
                    reject(error);
                }
            );
    });
};

export const getQuoteDetail = async (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getQuoteDetail(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data);
                    } else {
                        let errorMsg = (response && response.data && response.data.message) || '';
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data);
                    }
                },
                (error: any) => {
                    reject(error);
                }
            );
    });
};

export const updateInsuranceDataForAgency = (params: any) => async (dispatch: any) => {
    dispatch(setInsuranceData(params))
}

/**
 * function to update redux store while creating agency
 * @param params sectionLists for creating insurance for agency/agent
 * @returns 
 */
export const saveInsurance = (params: object) => async (dispatch: any) => {
    dispatch(createInsurance(params));
}

export const getPartnerInfo = () => {
    return new Promise((resolve, reject) => {
        InsuranceService.getPartnerInfo()
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response?.data?.data || [])
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getLeadDetails = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getLeadDetails(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response?.data?.data || [])
                        dispatch(setResubmissionLeadData(response?.data?.data))
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const updateDocumentStatus = (params: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.updateDocStatus(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response?.data?.data || [])
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const downloadAllPolicies = async (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceService.downloadAllPolicies(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data);
                    } else {
                        let errorMsg = (response && response.data && response.data.message) || '';
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data);
                    }
                },
                (error: any) => {
                    reject(error);
                }
            );
    });
};


export const generateDocUrls = (params: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.generateDocUrls(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response?.data?.data || [])
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getMappingAgencyList = (params: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getMappingAgencyList(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response?.data?.data || [])
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const loginAgency = (params: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.loginAgency(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response?.data?.data || [])
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getInsuranceListID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getLeadListID(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


// Agent Web ID 

export const getDashboardListingID = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getDashboardListingID(params)
            .then(
                (response: any) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        let data = response.data && response.data.data
                        dispatch(dashboardCountID(data));
                        resolve(data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const savePaymentInfo = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.savePaymentInfo(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                       // dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}



export const getaddonListID = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getaddonListID(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const insurerListID = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.insurerListID(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}



export const getAddonDetailsDataID = (params: any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceService.getAddonDetailsDataID(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(insuranceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}
export const paymentGenerateData = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.paymentGenerateData(params);

        if (response?.data?.status === STATUS_CODES['success']) {
            return response.data;
        } else {
            const errorMsg = response?.data?.message || '';
            if (errorMsg) toast.error(errorMsg);
            return response?.data;
        }
    } catch (error) {
        throw error;
    }
};

export const generatePaymentLinkUrl = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.generatePaymentLinkUrl(params);

        if (response?.data?.status === STATUS_CODES['success']) {
            if(response?.data?.message) toast.success(response.data.message);
            return response.data;
        } else {
            const errorMsg = response?.data?.message || '';
            if (errorMsg) toast.error(errorMsg);
            return response?.data;
        }
    } catch (error) {
        throw error;
    }
};

export const backorderSampleFiles = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.backorderSampleFiles(params);
        const responseData: any = response?.data;

        if (responseData?.status === STATUS_CODES['success']) {
            return responseData;
        } else {
            const errorMsg = responseData?.message || responseData?.errors || '';
            if (errorMsg) toast.error(errorMsg);
            return responseData;
        }
    } catch (error) {
        throw error;
    }
};

export const backorderApplicationDocUpload = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.backorderApplicationDocUpload(params);
        const responseData: any = response?.data;

        if (responseData?.status === STATUS_CODES['success']) {
            if (responseData?.message) toast.success(responseData.message);
            return responseData;
        } else {
            const errorMsg = responseData?.message || responseData?.errors || '';
            if (errorMsg) toast.error(errorMsg);
            return responseData;
        }
    } catch (error) {
        throw error;
    }
};

export const fetchAllDocuments = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.fetchAllDocuments(params);
        const responseData: any = response?.data;

        if (responseData?.status === STATUS_CODES['success']) {
            return responseData;
        } else {
            const errorMsg = responseData?.message || responseData?.errors || '';
            if (errorMsg) toast.error(errorMsg);
            return responseData;
        }
    } catch (error) {
        throw error;
    }
};

export const saveAdditionalDiscount = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.saveAdditionalDiscount(params);

        if (response?.data?.status === STATUS_CODES['success']) {
            return response.data;
        } else {
            const errorMsg = response?.data?.message || '';
            if (errorMsg) toast.error(errorMsg);
            return response?.data;
        }
    } catch (error) {
        throw error;
    }
};

export const getAdditionalDiscount = async (params: any) => {
    try {
        const response: APIResponse = await InsuranceService.getAdditionalDiscount(params);

        if (response?.data?.status === STATUS_CODES['success']) {
            return response.data;
        }
        return response?.data;
    } catch (error) {
        throw error;
    }
};
